"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = _interopRequireDefault(require("../icon"));
require("./icon-button.css");
var _excluded = ["ariaLabel", "children", "className", "highContrast", "href", "iconClass", "onClick", "path", "size", "style", "tagName"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * A button for use with a single `Icon`. Please see `Icon` for further information.
 */

var IconButton = function IconButton(_ref) {
  var ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    className = _ref.className,
    highContrast = _ref.highContrast,
    href = _ref.href,
    iconClass = _ref.iconClass,
    onClick = _ref.onClick,
    path = _ref.path,
    size = _ref.size,
    style = _ref.style,
    tagName = _ref.tagName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!children && !path) {
    return null;
  }
  var TagName = tagName || (href ? 'a' : 'button');
  return /*#__PURE__*/_react["default"].createElement(TagName, _extends({
    "aria-label": ariaLabel,
    className: (0, _classnames["default"])('sb-iconButton relative', _defineProperty(_defineProperty({}, className, Boolean(className)), 'sb-iconButton-highContrast', Boolean(highContrast))),
    href: href,
    onClick: onClick,
    style: _objectSpread({
      minWidth: '44px',
      minHeight: '44px'
    }, style)
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    children: children,
    className: (0, _classnames["default"])('absoluteCenter', _defineProperty({}, iconClass, Boolean(iconClass))),
    defaultHoverStyling: !highContrast,
    isInteractive: true,
    path: path,
    size: size
  }));
};
IconButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `aria-label` applied to button.
   */
  ariaLabel: _propTypes["default"].string,
  /**
   * optional prop to allow button to be seen more easily on dark backgrounds
   */
  highContrast: _propTypes["default"].bool,
  /**
   * optional href for use if button is to be a link
   */
  href: _propTypes["default"].string,
  /**
   * optional class applied to icon
   */
  iconClass: _propTypes["default"].string,
  /**
   * path of the icon to be used
   */
  path: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /**
   * Size passed through to Icon child
   */
  size: _propTypes["default"].string.isRequired,
  /**
   * Tag for this element can only be
   * `button` or `a`, since this component is interactive.
   */
  tagName: _propTypes["default"].oneOf(['a', 'button'])
} : {};
IconButton.defaultProps = {
  size: '24px'
};
IconButton.displayName = 'IconButton';
var _default = exports["default"] = IconButton;